






















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import PoliticalExposedPerson from '@master/model/kyc-form/external/PoliticalExposedPerson'
import { isEqual, isNull, isEmpty, snakeCase, startCase } from 'lodash/fp'
import { FormStructure } from '@master/model/structure/FormStructure'
import { FormOptions, IClientOptions } from '@master/model/kyc-form/FormOptions'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import AppForm from '@core/components/AppForm.vue'
import { isUndefined } from 'lodash'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppRadioSelection,
    AppForm
  }
})
export default class PEP extends Vue {
  @kycFormStore.State
  private kycForm!: KYCForm;

  @kycFormStore.State
  private formOptions!: FormOptions;

  private isModalVisible = false;
  private editedIndex = null;
  private newForm: PoliticalExposedPerson = new PoliticalExposedPerson();

  get editMode () {
    return !isNull(this.editedIndex)
  }

  get isClient2Included () {
    return this.kycForm.client2.personalDetails.included
  }

  get pepList () {
    return this.kycForm.clientDeclaration.pepList
  }

  isPepHidden (policyholderName: keyof IClientOptions) {
    // Filter out if the pep holder is client 2 & client 2 is not included
    return (policyholderName === 'C2' && !this.isClient2Included) ? 'hide' : ''
  }

  isOthersSourceOfFundsSelected (): boolean {
    return !this.newForm.sourceOfFunds.includes('others')
  }

  isOthersSourceOfWealthSelected (): boolean {
    return !this.newForm.sourceOfWealth.includes('others')
  }

  beforeModalClose () {
    if (!this.isFormEmpty() && !this.editMode) {
      if (window.confirm('Exit without saving this form? All data will be lost.')) {
        this.isModalVisible = false
      } else this.isModalVisible = !this.saveForm()
    } else if (!this.isFormEmpty() && this.editMode) {
      if (!isEqual(this.pepList[this.editedIndex], this.newForm)) {
        if (window.confirm('Save changes?')) {
          this.isModalVisible = !this.saveForm()
        } else this.isModalVisible = false
      } else {
        this.isModalVisible = false
      }
    } else {
      this.isModalVisible = false
    }
  }

  afterModalClosed () {
    this.editedIndex = null
    this.newForm = new PoliticalExposedPerson()
  }

  isPepListed (index): boolean {
    if (!this.editMode) {
      return this.pepList.some((pep) => pep.fullName === this.newForm.fullName)
    } else {
      return this.pepList.some(
        (pep, i) => i !== index && pep.fullName === this.newForm.fullName
      )
    }
  }

  validatePep (): string[] {
    const requiredPepField = ['policyholderName', 'fullName', 'nric', 'occupation', 'nameOfEmployer', 'sourceOfFunds',
      'sourceOfWealth', 'category']
    const missingField = []
    for (const field of requiredPepField) {
      if (
        this.newForm[field] === undefined ||
        this.newForm[field] === null ||
        this.newForm[field] === ''
      ) {
        missingField.push(this.polishErrorField(field))
      } else if (this.newForm[field] instanceof Object) {
        if (this.newForm[field].length === 0) {
          missingField.push(this.polishErrorField(field))
        } else if (field === 'sourceOfFunds' && this.newForm[field].includes('others') && isEmpty(this.newForm.fundOthers)) {
          missingField.push('Source of Funds Others Specification')
        } else if (field === 'sourceOfWealth' && this.newForm[field].includes('others') && isEmpty(this.newForm.wealthOthers)) {
          missingField.push('Source of Wealth Others Specification')
        }
      }
    }
    return missingField
  }

  polishErrorField (field) {
    return startCase(snakeCase(field).replaceAll('_', ' '))
  }

  isFormEmpty (): boolean {
    let empty = true
    for (const key in this.newForm) {
      if (key !== 'skipStorageKeys' && !isEmpty(this.newForm[key])) {
        empty = false
      }
    }
    return empty
  }

  deleteForm (pep, index) {
    if (confirm(`Are you sure to delete ${pep.fullName} form?`)) {
      this.kycForm.clientDeclaration.pepList = this.pepList.filter(
        (pep, i) => i !== index
      )
      this.$emit('save')
    }
  }

  editForm (pep, index) {
    for (const key in pep) {
      this.newForm[key] = pep[key]
    }
    this.editedIndex = index
    this.isModalVisible = true
  }

  relationshipNotStated () {
    if (this.newForm.category === 'cat2' && this.newForm.familyMemberRelationship === '') {
      return 'Please specify relationship in category 2'
    }
    if (this.newForm.category === 'cat3' && this.newForm.closeAssociateRelationship === '') {
      return 'Please specify relationship in category 3'
    }
  }

  somePersonDetailsIsEmpty () {
    if (!this.showPersonDetail()) return

    return [this.newForm.personRank, this.newForm.personName, this.newForm.personCountryOfAppointment]
      .some(element => {
        return isEmpty(element) || isUndefined(element)
      })
  }

  saveForm () {
    if (this.isPepListed(this.editedIndex)) {
      alert(
        `The form for ${this.newForm.fullName} has already been created. You are not allowed to create multiple PEP forms for the same person.`
      )
      return false
    }

    if (this.validatePep().length > 0) {
      alert(
        `${this.validatePep().join(
          ', '
        )} cannot be empty. Please review the details at the respective sections.`
      )
      return false
    }

    const relationshipMsg = this.relationshipNotStated()
    if (relationshipMsg) {
      alert(relationshipMsg)
      return false
    }

    if (this.somePersonDetailsIsEmpty()) {
      alert('Please fill in all the person details in section c')
      return false
    }

    if (this.editMode) {
      // this is to trigger kycform watcher to do validation (directly changing items in array doesnt work somehow)
      this.$set(this.kycForm.clientDeclaration.pepList, this.editedIndex, this.newForm)
    } else {
      this.pepList.push(this.newForm)
    }
    this.$emit('save')
    this.isModalVisible = false
  }

  showPersonDetail () {
    return this.newForm.category === 'cat2' || this.newForm.category === 'cat3'
  }

  @Watch('newForm.category')
  categoryChanged (cat) {
    // only clear the respective field when new category value is not specific value
    if (cat !== 'cat2') this.newForm.familyMemberRelationship = ''
    if (cat !== 'cat3') this.newForm.closeAssociateRelationship = ''
  }

  @Watch('newForm.sourceOfFunds')
  sourceOfFundChange (sof) {
    if (!sof.includes('others')) {
      this.newForm.fundOthers = ''
    }
  }

  @Watch('newForm.sourceOfWealth')
  sourceOfWealthChange (sow) {
    if (!sow.includes('others')) {
      this.newForm.wealthOthers = ''
    }
  }

  @Watch('newForm.category')
  categoryOptionOnChange (cat) {
    if (cat !== 'cat2' && cat !== 'cat3') {
      this.newForm.personName = ''
      this.newForm.personRank = ''
      this.newForm.personCountryOfAppointment = ''
    }
  }

  get PoliticalExposedPersonStructure (): FormStructure<PoliticalExposedPerson> {
    return [
      {
        label: 'Name of Policy Holder',
        key: 'policyholderName',
        classes: ['colspan'],
        options: this.formOptions.clientOptions
      }, {
        label: 'Full Name',
        key: 'fullName',
        tooltip: {
          content: '<div style="width:360px">Full Name of Customer / Appointed Person appointed to act on behalf of customer / Beneficial Owner of Customer / Connected Party of Customer </div>'
        }
      }, {
        label: 'NRIC/FIN/Passport No.',
        key: 'nric'
      }, {
        label: 'Occupation / Designation',
        key: 'occupation'
      }, {
        label: 'Name Of Employer',
        key: 'nameOfEmployer'
      }, {
        label: 'Source of Funds applicable to Foreign PEP',
        key: 'sourceOfFunds',
        type: 'checkbox',
        checkboxColumnNo: 1,
        options: [
          { label: 'Employment / Trade Income', value: 'employment' },
          { label: 'Savings', value: 'savings' },
          {
            label: 'Others:',
            value: 'others',
            others: {
              key: 'fundOthers',
              disabled: (sof) => !sof.sourceOfFunds.includes('others')
            }
          }
        ]
      }, {
        label: 'Source of Wealth applicable to Foreign PEP',
        key: 'sourceOfWealth',
        type: 'checkbox',
        checkboxColumnNo: 1,
        options: [
          { label: 'Employment / Trade Income', value: 'employment' },
          { label: 'Investment Income', value: 'investment' },
          { label: 'Rental Income', value: 'rental' },
          {
            label: 'Others:',
            value: 'others',
            others: {
              key: 'wealthOthers',
              disabled: (sof) => !sof.sourceOfWealth.includes('others')
            }
          }
        ]
      }
    ]
  }

  get personDetailDataStructure (): FormStructure<PoliticalExposedPerson> {
    return [
      {
        label: 'Full Name',
        key: 'personName',
        classes: ['colspan']
      }, {
        label: 'Rank / Position Held',
        key: 'personRank',
        classes: ['colspan']
      }, {
        label: 'Country of Appointment',
        key: 'personCountryOfAppointment',
        classes: ['colspan']
      }
    ]
  }
}
